import { shallow } from 'zustand/shallow';
import { selectVisibleNodeIds, useMindmapStore } from '../../store';
import { NodeWrapper } from './NodeWrapper';
import { useNodeResizeObserver } from './useNodeResizeObserver';

/** Renders every visible node in order; re-renders only when the list of ids changes. */
export const NodeLayer = () => {
  const ids = useMindmapStore(selectVisibleNodeIds, shallow);
  const resizeObserver = useNodeResizeObserver();
  return (
    <div className="cm-nodes">
      {ids.map((id) => (
        <NodeWrapper key={id} id={id} resizeObserver={resizeObserver} />
      ))}
    </div>
  );
};
